import { Link, NavLink } from 'react-router';

import '../assets/styles/privacy-policy.scss';
import { routes } from '../const/routes';
import {
  CATEGORIES_TECHNOLOGIES,
  RECIPIENTS,
} from '../components/privacy-policy/data';

const PrivacyPolicy = () => (
  <main className="privacy-policy-page">
    <ul className="breadcrumbs">
      <li>
        <NavLink to={routes.landingPage}>Home</NavLink>
      </li>
      <li>
        <NavLink
          to={routes.privacyPolicy}
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          Privacy Policy
        </NavLink>
      </li>
    </ul>
    <div className="content">
      <h1>PRIVACY POLICY</h1>
      <div>
        <p>
          laestimator.ai <br />
          Last updated: August 20, 2026
        </p>
      </div>
      <ul>
        {/* 1 */}
        <li>
          <section>
            <h2>Who We Are and What This Policy Covers</h2>

            <ul className="inner-list">
              <li>
                <h3>Controller</h3>
                <div>
                  <p>
                    The controller of your personal data is LaEurope Sp. z o.o.,
                    a limited liability company incorporated under the laws of
                    Poland, trading as Lasoft, with its registered office at ul.
                    Piotrkowska 148/150, 90-063 Łódź, Poland (NIP: 8971848582;
                    REGON: 368844046) (hereinafter – “Lasoft”, “We”, “Us”, or
                    “Our”).
                  </p>
                </div>
              </li>

              <li>
                <h3>Contact</h3>
                <div>
                  <p>
                    For any questions about this Policy or about how We handle
                    personal data, write to{' '}
                    <a
                      href="mailto:info@lasoft.org"
                      content="info@lasoft.org"
                      rel="nofollow"
                    >
                      info@lasoft.org
                    </a>
                    .
                  </p>
                </div>
              </li>

              <li>
                <h3>Data Protection Officer</h3>
                <div>
                  <p>
                    We have not appointed a Data Protection Officer, as We are
                    not required to do so under Article 37 GDPR” or the DPO’s
                    contact details.
                  </p>
                </div>
              </li>

              <li>
                <h3>Purpose of this Policy</h3>
                <div>
                  <p>
                    This Policy is a privacy notice provided under Articles 13
                    and 14 of the General Data Protection Regulation (EU)
                    2016/679 (“GDPR”). It explains what personal data We
                    collect, why We collect it, the legal basis on which We
                    rely, who receives it, how long We keep it, and what rights
                    you have. It is not a contract and does not require your
                    acceptance.
                  </p>
                </div>
              </li>

              <li>
                <h3>Scope</h3>
                <div>
                  <p>
                    This Policy applies to the AI-powered software project
                    estimation service available at laestimator.ai and its
                    subdomains (the “Service”). It should be read together with
                    Our Terms of Use, which govern your use of the Service.
                    Where a term is defined in the Terms of Use, it has the same
                    meaning here.
                  </p>
                </div>
              </li>

              <li>
                <h3>Who it applies to</h3>
                <div>
                  <p>
                    This Policy applies to all Users of the Service, including
                    Users in the European Economic Area, the United Kingdom, and
                    the United States.
                  </p>
                </div>
              </li>
            </ul>
          </section>
        </li>
        {/* 2 */}
        <li>
          <section>
            <h2>Definitions</h2>
            <div>
              <p>For the purposes of this Policy:</p>
              <ul className="disc">
                <li>
                  <strong>Personal Data</strong> – any information relating to
                  an identified or identifiable natural person.
                </li>
                <li>
                  <strong>Processing</strong> – any operation performed on
                  personal data, including collection, recording, storage, use,
                  disclosure, and erasure.
                </li>
                <li>
                  <strong>Controller</strong> – the person or body that
                  determines the purposes and means of processing personal data.
                </li>
                <li>
                  <strong>Processor</strong> – a person or body that processes
                  personal data on behalf of a controller and on its documented
                  instructions.
                </li>
                <li>
                  <strong>User</strong> – any individual who accesses or uses
                  the Service.
                </li>
                <li>
                  <strong>Estimator Inputs</strong> – the project descriptions,
                  selections, budget indications, and any files you enter into
                  or upload to the estimation flow.
                </li>
                <li>
                  <strong>Cookies</strong> – small text files and similar
                  technologies (including pixels, tags, local storage, and
                  software development kits) placed on or read from your device.
                </li>
                <li>
                  <strong>CRM</strong> – the customer relationship management
                  system We use to manage contacts, leads, and communications.
                  Our CRM is HubSpot.
                </li>
                <li>
                  <strong>Communication infrastructure</strong> – the business
                  email and productivity tools We use to correspond with you. We
                  use Google Workspace, including Gmail. Google Workspace is not
                  Our CRM.
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 3 */}
        <li>
          <section>
            <h2>What Personal Data We Collect</h2>
            <div>
              <p>
                We collect only the personal data described in this section. The
                amount We hold about you depends on how you use the Service —
                browsing the Website alone generates far less data than
                completing the estimation flow and requesting a result.
              </p>

              <ul className="inner-list">
                <li>
                  <h3>Data You Provide to Us</h3>
                  <div>
                    <p>
                      If you complete the estimation flow, submit a contact
                      form, subscribe to Our communications, or write to Us
                      directly, We collect:
                    </p>

                    <ul className="disc">
                      <li>first name and, where you provide it, last name;</li>
                      <li>business email address;</li>
                      <li>phone number, where you choose to provide it;</li>
                      <li>
                        company name and your position, where you choose to
                        provide them;
                      </li>
                      <li>
                        your Estimator Inputs - project description, requested
                        features, budget range, timeline expectations, and
                        similar information you enter into the estimation flow;
                      </li>
                      <li>
                        any files you upload, such as specifications,
                        requirement documents, briefs, diagrams, or wireframes,
                        together with any personal data those files happen to
                        contain;
                      </li>
                      <li>
                        the content of your messages and any correspondence with
                        Us.
                      </li>
                    </ul>

                    <p>
                      Providing this data is voluntary. However, We need at
                      least your name and email address in order to deliver an
                      estimate to you; if you do not provide them, We will not
                      be able to send you the result.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Data Collected Automatically</h3>
                  <div>
                    <p>
                      When you access the Service, the following is collected
                      automatically through server logs, cookies, and analytics
                      technologies:
                    </p>

                    <ul className="disc">
                      <li>
                        IP address and the approximate geographic location
                        derived from it;
                      </li>
                      <li>browser type, version, and language settings;</li>
                      <li>device type and operating system;</li>
                      <li>
                        pages and screens visited, session duration, scroll and
                        click behavior, and referring URLs;
                      </li>
                      <li>date and time of each session;</li>
                      <li>
                        interactions within the estimation flow, such as which
                        options you select and how far you progress.
                      </li>
                    </ul>

                    <p>
                      Non-essential cookies and analytics technologies are
                      activated only after you consent to them, as described in
                      section 5.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Data We Receive from Third Parties</h3>
                  <div>
                    <ul className="disc">
                      <li>
                        advertising and social platforms, where you interact
                        with Our campaigns and the platform reports that
                        interaction to Us (see section 6);
                      </li>
                      <li>
                        publicly available business sources, where We verify
                        company details you have supplied;
                      </li>
                      <li>
                        colleagues or business contacts who refer you to Us, in
                        which case We will tell you the source when We first
                        contact you.
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <h3>Data We Ask You Not to Provide</h3>
                  <div>
                    <p>
                      We do not seek, and We ask you not to enter into the
                      Service or include in uploaded files:
                    </p>

                    <ul className="disc">
                      <li>
                        special categories of personal data within the meaning
                        of Article 9 GDPR, such as data revealing health, racial
                        or ethnic origin, political opinions, religious beliefs,
                        trade union membership, genetic or biometric data, or
                        data concerning sex life or sexual orientation;
                      </li>
                      <li>
                        government-issued identification numbers, passport or
                        identity document details;
                      </li>
                      <li>payment card numbers or bank credentials;</li>
                      <li>
                        personal data relating to other people, unless you have
                        a lawful basis to disclose it to Us.
                      </li>
                    </ul>

                    <p>
                      If such data reaches Us despite this, We will delete it as
                      soon as We become aware of it, unless We are legally
                      required to retain it.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 4 */}
        <li>
          <section>
            <h2>Purposes and Legal Basis for Processing</h2>
            <div>
              <p>
                We process personal data only where a legal basis under Article
                6 GDPR applies. Different activities rely on different bases, as
                set out below.
              </p>

              <ul className="inner-list">
                <li>
                  <h3>Providing the Estimation Service</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong> to operate the AI-powered
                      estimator, process your Estimator Inputs and uploaded
                      files, generate a project cost and scope estimate, and
                      deliver the result to you.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(b) GDPR —
                      processing necessary to take steps at your request prior
                      to entering into a contract.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Responding to Inquiries</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong> to answer your messages, follow
                      up on an estimate you have requested, arrange and hold
                      consultations, and prepare a proposal where you ask for
                      one.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(b) GDPR -
                      pre-contractual measures taken at your request.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Marketing Communications</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong> to send newsletters, service
                      updates, and marketing offers.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(a) GDPR - your
                      consent, which you may withdraw at any time with effect
                      for the future, without affecting the lawfulness of
                      processing carried out before withdrawal. Every message We
                      send includes an unsubscribe link, and you may also write
                      to{' '}
                      <a
                        href="mailto:info@lasoft.org"
                        content="info@lasoft.org"
                        rel="nofollow"
                      >
                        info@lasoft.org
                      </a>
                      .
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Analytics and Service Improvement</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong>to understand how the Service is
                      used, measure the performance of Our campaigns, and
                      improve the accuracy and usability of the estimator.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(a) GDPR - your
                      consent, given through the cookie banner, for the
                      placement and reading of non-essential cookies and for the
                      analytics processing that follows from them. Where We
                      analyze data that does not depend on cookies, such as
                      aggregated server-side statistics, We rely on Article
                      6(1)(f) GDPR - Our legitimate interest in maintaining and
                      improving the Service.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Security, Fraud Prevention, and Prevention of Abuse</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong> to protect the Service and its
                      Users against unauthorized access, denial-of-service
                      attempts, automated scraping, model-extraction attacks,
                      and other misuse; to keep security logs; and to
                      investigate incidents.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(f) GDPR - Our
                      legitimate interest, and the legitimate interest of Our
                      Users, in the security and integrity of the Service and of
                      Our network and information systems. Recital 49 GDPR
                      expressly recognizes this as a legitimate interest.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Compliance with Legal Obligations</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong> to comply with obligations to
                      which We are subject, including accounting and tax
                      record-keeping and responding to lawful requests from
                      public authorities.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(c) GDPR -
                      compliance with a legal obligation.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Establishing, Exercising, or Defending Legal Claims</h3>
                  <div>
                    <p>
                      <strong>Purpose:</strong> to retain records necessary to
                      establish, exercise, or defend legal claims, including
                      claims arising from your use of the Service.
                      <br />
                      <strong>Legal basis:</strong> Article 6(1)(f) GDPR - Our
                      legitimate interest in protecting Our legal position.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Balancing Test</h3>
                  <div>
                    <p>
                      Where We rely on legitimate interests, We have carried out
                      a balancing assessment weighing those interests against
                      your rights and freedoms. You may request a summary of
                      that assessment by writing to{' '}
                      <a
                        href="mailto:info@lasoft.org"
                        content="info@lasoft.org"
                        rel="nofollow"
                      >
                        info@lasoft.org
                      </a>
                      , and you have the right to object to such processing
                      under section 9.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 5 */}
        <li>
          <section>
            <h2>Cookies and Similar Technologies</h2>
            <div>
              <ul className="inner-list">
                <li>
                  <h3>How Consent Works</h3>
                  <div>
                    <p>
                      Strictly necessary cookies are placed automatically,
                      because the Service cannot function without them. No
                      consent is required for these.
                      <br />
                      All other cookies and similar technologies: functional,
                      analytics, behavior-analytics, and marketing remain
                      inactive until you give consent by a clear affirmative
                      action in Our cookie banner. Continuing to browse,
                      scrolling, closing the banner, or ignoring it does not
                      constitute consent and does not activate any non-essential
                      technology.
                      <br />
                      Rejecting non-essential cookies is as easy as accepting
                      them: the banner presents “Accept all” and “Reject all”
                      options with equal prominence at the same level, alongside
                      a link to granular settings where you can consent to some
                      categories and not others.
                      <br />
                      You may change or withdraw your choice at any time.
                      Withdrawal is as easy as giving consent and takes effect
                      for the future.
                    </p>
                  </div>
                </li>
                <li>
                  <h3>Categories and Technologies We Use</h3>
                  <div className="list-table-wrapper">
                    <p>
                      The table below is the full inventory of cookie-based and
                      similar technologies deployed on the Service.
                    </p>
                    {/* ------------ TABLE ------------- */}
                    <div className="list-table__desktop-heading">
                      <div>Technology</div>
                      <div>Category</div>
                      <div>Purpose</div>
                      <div>Consent required</div>
                      <div>Provider and privacy terms</div>
                    </div>
                    <ul className="list-table">
                      {CATEGORIES_TECHNOLOGIES.map((item, index) => (
                        <li key={index}>
                          {Object.entries(item).map(([key, value]) => (
                            <div
                              className={`${key === 'technology' ? 'mobile-heading' : ''}`}
                            >
                              <div className="mobile-label">
                                {key === 'consentRequired'
                                  ? 'Consent Required'
                                  : key === 'ProviderAndPrivacyTerms'
                                    ? 'Provider & Privacy Terms'
                                    : key}
                                :
                              </div>
                              <div>{value}</div>
                            </div>
                          ))}
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>

                <li>
                  <h3>A Note on Google Tag Manager</h3>
                  <div>
                    <p>
                      Google Tag Manager is a tag management system, not an
                      analytics or advertising technology in its own right. It
                      does not set cookies to profile you; it is the mechanism
                      through which the other technologies listed above are
                      loaded. What matters for your privacy is which tags it
                      deploys. Google Tag Manager is configured so that it loads
                      an analytics or marketing tag only after you have
                      consented to the corresponding category, and each deployed
                      tag remains subject to the consent requirement shown for
                      it in the table.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>A Note on Google Analytics</h3>
                  <div>
                    <p>
                      Google Analytics does not identify you by name, but it
                      assigns a pseudonymous identifier to your browser or
                      device and processes it together with your IP address and
                      usage data. Under the GDPR this is pseudonymous personal
                      data, not anonymous data. Aggregated reports produced from
                      it are a separate matter: aggregation happens in the
                      reporting output, and does not make the underlying
                      processing anonymous.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Managing Cookies in Your Browser</h3>
                  <div>
                    <p>
                      Independently of Our banner, you can block or delete
                      cookies through your browser settings. Doing so may reduce
                      the Service's functionality; blocking strictly necessary
                      cookies may prevent it from working at all. General
                      guidance is available at{' '}
                      <a
                        href="https://allaboutcookies.org/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                      >
                        www.allaboutcookies.org
                      </a>
                      .
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 6 */}
        <li>
          <section>
            <h2>Who Receives Your Personal Data</h2>
            <div>
              <p>
                We do not sell personal data. We share it only with the
                recipients listed below, and only to the extent necessary for
                the purpose stated. Each processor acts on Our documented
                instructions under a data processing agreement concluded in
                accordance with Article 28 GDPR.
              </p>
              <ul className="inner-list">
                <li>
                  <h3>Inventory of Recipients</h3>
                  <div className="list-table-wrapper">
                    {/* ----------- TABLE ------------- */}
                    <div className="list-table__desktop-heading">
                      <div>Recipient</div>
                      <div>Role</div>
                      <div>What it receives and why</div>
                      <div>Location</div>
                      <div>Transfer mechanism</div>
                    </div>
                    <ul className="list-table">
                      {RECIPIENTS.map((item, index) => (
                        <li key={index}>
                          {Object.entries(item).map(([key, value]) => (
                            <div
                              className={`${key === 'recipient' ? 'mobile-heading' : ''}`}
                            >
                              <div className="mobile-label">
                                {key === 'receives'
                                  ? 'What it receives and why'
                                  : key === 'transfer'
                                    ? 'Transfer Mechanism'
                                    : key}
                                :
                              </div>
                              <div>{value ? value : '-'}</div>
                            </div>
                          ))}
                        </li>
                      ))}
                    </ul>

                    <p>
                      Where a recipient is marked as a{' '}
                      <strong>joint controller</strong> — currently LinkedIn and
                      Meta in respect of their tracking technologies — We and
                      that provider jointly determine the purposes and means of
                      the measurement processing. A summary of the essence of
                      the joint controller arrangement is available from each
                      provider, and you may exercise your rights against either
                      party.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Artificial Intelligence Processing</h3>
                  <div>
                    <p>
                      Generating an estimate requires your Estimator Inputs —
                      and the content of any files you upload — to be processed
                      by a large language model. The following applies to that
                      processing:
                    </p>

                    <ul className="disc">
                      <li>
                        the provider acts as Our processor, under a data
                        processing agreement concluded in accordance with
                        Article 28 GDPR;
                      </li>
                      <li>
                        We require Our AI provider, by contract, not to use your
                        Estimator Inputs or uploaded files to train or improve
                        its own models. This matches the commitment given in
                        clause 6.5 of Our Terms of Use
                      </li>
                      <li>
                        the provider’s own retention of prompt and file data is
                      </li>
                      <li>
                        Lasoft uses your Estimator Inputs to improve the
                        accuracy of the estimator only in aggregated,
                        anonymized, or de-identified form, so that they no
                        longer identify you or your project;
                      </li>
                      <li>
                        a member of Our team may review an estimate and the
                        inputs behind it in order to respond to your inquiry or
                        prepare a proposal.
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <h3>Code Repositories</h3>
                  <div>
                    <p>
                      We use GitHub for source code management and version
                      control. GitHub hosts Our code; it does not receive
                      Estimator Inputs, uploaded files, or User contact data in
                      the ordinary course of operating the Service. GitHub is
                      mentioned here only for completeness and in connection
                      with the vulnerability disclosure procedure in section
                      10.1.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 7 */}
        <li>
          <section>
            <h2>How Long We Keep Your Data</h2>
            <div>
              <p>
                We keep personal data only for as long as necessary for the
                purpose for which it was collected. Because the appropriate
                period differs by data type, the criteria We apply are set out
                below.
              </p>

              <ul className="inner-list">
                <li>
                  <h3>Criteria We Apply</h3>
                  <ul className="disc">
                    <li>
                      <strong>Estimator Inputs and uploaded files. </strong>{' '}
                      Kept for as long as needed to generate and deliver your
                      estimate and to answer any follow-up, and thereafter for
                      as long as an active business discussion continues. Where
                      no discussion follows, they are deleted once the inquiry
                      is closed as inactive. If We enter into a contract with
                      you, project materials are retained for the duration of
                      the engagement and the applicable limitation period for
                      claims.
                    </li>
                    <li>
                      <strong>Inquiries and correspondence. </strong> Kept for
                      as long as needed to handle the inquiry and, thereafter,
                      for the period during which a claim could still arise from
                      it — that is, the limitation period under Polish law
                      applicable to the relevant type of claim.
                    </li>
                    <li>
                      <strong>CRM lead records. </strong> Kept for as long as
                      the contact remains a live commercial prospect. A record
                      is reviewed once the contact has been inactive for a
                      defined period and is deleted or minimized where the
                      commercial relationship is not being pursued.
                    </li>
                    <li>
                      <strong>Marketing subscription data. </strong> Kept until
                      you withdraw consent or unsubscribe. After that We retain
                      only the minimum record needed to prove that consent was
                      given and withdrawn, and to ensure We do not contact you
                      again.
                    </li>
                    <li>
                      <strong>Customer and accounting records. </strong> Kept
                      for the period required by Polish accounting and tax law,
                      calculated from the end of the relevant financial year.
                    </li>
                    <li>
                      <strong>Analytics and cookie data. </strong> Kept for the
                      retention period configured in each analytics tool, or
                      until you withdraw your consent, whichever comes first.
                      Withdrawing consent stops further collection; it does not
                      by itself erase data already collected, which you may
                      request separately.
                    </li>
                    <li>
                      <strong>Server and security logs. </strong> Kept for the
                      short period needed to detect, investigate, and respond to
                      security incidents and to maintain the integrity of the
                      Service, and longer only where a specific incident is
                      under investigation.
                    </li>
                    <li>
                      <strong>Records relating to legal claims. </strong> Kept
                      until the claim is finally resolved and the period for
                      challenging that resolution has expired.
                    </li>
                  </ul>
                </li>

                <li>
                  <h3></h3>
                  <p>
                    Where none of the above applies, We assess the necessary
                    period by reference to the purpose of the processing, the
                    existence of any legal obligation to retain the data, and
                    the limitation period for potential claims. When a retention
                    period ends, data is deleted or irreversibly anonymized.
                  </p>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 8 */}
        <li>
          <section>
            <h2>International Transfers</h2>
            <div>
              <p>
                <strong className="bold">8.1</strong> Several of the providers
                listed in section 6 are established in the United States or
                process data there. Where personal data is transferred outside
                the European Economic Area, We rely on one of the following
                mechanisms, as identified for each recipient in the table in
                section 6.1:
              </p>

              <ul className="disc">
                <li>
                  <strong>Adequacy decision. </strong> For recipients in the
                  United States that are certified under the EU-US Data Privacy
                  Framework, the transfer relies on the European Commission’s
                  adequacy decision of 10 July 2023. You can check a given
                  organization’s certification on the official Data Privacy
                  Framework list.
                </li>
                <li>
                  <strong>Standard Contractual Clauses. </strong> For recipients
                  not covered by an adequacy decision, We conclude the Standard
                  Contractual Clauses approved by the European Commission under
                  Implementing Decision (EU) 2021/914.
                </li>
                <li>
                  <strong>Supplementary measures. </strong> Where a transfer
                  impact assessment indicates it is necessary, We apply
                  additional technical and organizational safeguards, such as
                  encryption in transit and at rest and restrictions on the
                  categories of data transferred.
                </li>
              </ul>

              <p>
                <strong className="bold">8.2</strong> Where We share data with
                professional advisers providing legal, tax, or audit services
                outside the EEA, We do so under confidentiality agreements and,
                where required, the Standard Contractual Clauses.
              </p>
              <p>
                <strong className="bold">8.3</strong> You may request a copy of
                the safeguards applied to a specific transfer by writing to{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                .
              </p>
            </div>
          </section>
        </li>
        {/* 9 */}
        <li>
          <section>
            <h2>Your Rights</h2>
            <div>
              <p>
                Under the GDPR you have the following rights in relation to your
                personal data:
              </p>
              <ul className="disc">
                <li>
                  <strong>Access </strong> (Article 15) – to obtain confirmation
                  of whether We process your data and, if so, a copy of it and
                  information about the processing.
                </li>
                <li>
                  <strong>Rectification </strong> (Article 16) – to have
                  inaccurate data corrected and incomplete data completed.
                </li>
                <li>
                  <strong>Erasure </strong> (Article 17) – to have your data
                  deleted where one of the grounds in Article 17 applies.
                </li>
                <li>
                  <strong>Restriction of processing </strong> (Article 18) – to
                  have processing limited in the circumstances set out in
                  Article 18.
                </li>
                <li>
                  <strong>Data portability </strong> (Article 20) – to receive
                  the data you provided to Us, where processing is based on
                  consent or contract and carried out by automated means, in a
                  structured, commonly used, machine-readable format, and to
                  have it transmitted to another controller where technically
                  feasible.
                </li>
                <li>
                  <strong>Objection </strong> (Article 21) – to object at any
                  time, on grounds relating to your particular situation, to
                  processing based on Our legitimate interests. Where you object
                  to processing for direct marketing purposes, We will stop that
                  processing without exception and without you needing to give
                  reasons.
                </li>
                <li>
                  <strong>Withdrawal of consent </strong> (Article 7(3)) – to
                  withdraw consent at any time, without affecting the lawfulness
                  of processing carried out before withdrawal.
                </li>
                <li>
                  <strong>Automated decision-making </strong> (Article 22) – not
                  to be subject to a decision based solely on automated
                  processing that produces legal effects concerning you or
                  similarly significantly affects you. The estimator generates
                  an indicative estimate; it does not make any decision about
                  you, and it produces no legal or similarly significant effect.
                  We do not carry out automated decision-making within the
                  meaning of Article 22.
                </li>
              </ul>

              <ul className="inner-list">
                <li>
                  <h3>How to Exercise Your Rights</h3>
                  <div>
                    <p>
                      Write to{' '}
                      <a
                        href="mailto:info@lasoft.org"
                        content="info@lasoft.org"
                        rel="nofollow"
                      >
                        info@lasoft.org
                      </a>
                      , describing the right you wish to exercise. We may ask
                      for information reasonably needed to confirm your identity
                      before We act. Exercising these rights is free of charge,
                      unless a request is manifestly unfounded or excessive.
                    </p>

                    <p>
                      We will respond without undue delay and in any event
                      within one month of receiving your request. Where the
                      request is complex or where We have received a number of
                      requests, that period may be extended by two further
                      months; if it is, We will inform you of the extension and
                      the reasons for it within one month of receiving the
                      request.
                    </p>
                  </div>
                </li>

                <li>
                  <h3>Right to Lodge a Complaint</h3>
                  <div>
                    <p>
                      If you consider that Our processing of your personal data
                      infringes the GDPR, you have the right to lodge a
                      complaint with a supervisory authority.
                    </p>
                    <p>
                      Because Our controller is established in Poland, the
                      competent lead authority is: President of the Personal
                      Data Protection Office (Prezes Urzędu Ochrony Danych
                      Osobowych – UODO) ul. Stawki 2, 00-193 Warsaw, Poland{' '}
                      <br />
                      <a
                        href="https://www.uodo.gov.pl/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                      >
                        www.uodo.gov.pl
                      </a>
                    </p>
                    <p>
                      You may also lodge a complaint with the supervisory
                      authority of the EU Member State of your habitual
                      residence or place of work, or of the place where the
                      alleged infringement occurred. You additionally have the
                      right to an effective judicial remedy against Us or
                      against a supervisory authority.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 10 */}
        <li>
          <section>
            <h2>Data Security</h2>
            <div>
              <p>
                We implement appropriate technical and organizational measures
                to protect personal data against unauthorized access, accidental
                loss, destruction, alteration, or disclosure, taking into
                account the state of the art, implementation costs, and the
                risks involved. These measures include:
              </p>
              <ul className="disc">
                <li>
                  encryption of data in transit using TLS, and encryption at
                  rest for stored files;
                </li>
                <li>
                  role-based access controls and multi-factor authentication for
                  administrative access;
                </li>
                <li>separation of production and development environments;</li>
                <li>
                  logging and monitoring of access to systems containing
                  personal data;
                </li>
                <li>
                  regular security assessments and vulnerability scanning;
                </li>
                <li>
                  staff training on data protection and confidentiality
                  obligations;
                </li>
                <li>
                  contractual confidentiality and security commitments from Our
                  processors.
                </li>
              </ul>
              <p>
                No method of electronic storage or transmission is entirely
                secure, and We cannot guarantee absolute security. If We become
                aware of a personal data breach likely to result in a risk to
                your rights and freedoms, We will notify the President of the
                Personal Data Protection Office within 72 hours in accordance
                with Article 33 GDPR, and will inform you directly where Article
                34 GDPR requires it. If you believe your data may have been
                compromised, please notify Us immediately at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                .
              </p>
              <ul className="inner-list">
                <li>
                  <h3>Vulnerability Disclosure</h3>
                  <div>
                    <p>
                      If you have discovered an issue that you believe is an
                      in-scope security vulnerability, please email{' '}
                      <a
                        href="mailto:info@lasoft.org"
                        content="info@lasoft.org"
                        rel="nofollow"
                      >
                        info@lasoft.org
                      </a>{' '}
                      and include, where possible:
                    </p>
                    <ul className="disc">
                      <li>
                        a proof of concept or instructions: screenshots, video,
                        or written steps, showing how to reproduce the
                        vulnerability;
                      </li>
                      <li>
                        the entry fields, filters, or other input objects
                        involved;
                      </li>
                      <li>
                        your assessment of the risk and of the exploitability of
                        the issue;
                      </li>
                      <li>
                        a way for Us to reach you with follow-up questions.
                      </li>
                    </ul>
                    <p>
                      Proposing a fix is welcome but not required. A report
                      without sufficient detail may delay Our response. We will
                      not pursue action against researchers who report in good
                      faith, act within the scope of this procedure, and do not
                      access, modify, or exfiltrate other Users’ data.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 11 */}
        <li>
          <section>
            <h2>Children and Young People</h2>
            <div>
              <p>
                The Service is intended for business and professional use and is
                not directed to children. Consistent with clause 3 of Our Terms
                of Use, the Service is intended for individuals aged 18 or over.
                Individuals aged 16 or 17 may use it only with the consent and
                under the supervision of a parent or legal guardian, who accepts
                the Terms of Use on their behalf.
              </p>
              <p>
                We do not knowingly collect personal data from anyone under 16.
                Where information society services are offered directly to a
                child, Article 8 GDPR read together with Polish law, sets the
                age of consent at 16. If you believe that a person under 16, or
                a person aged 16 or 17 without the required parental consent,
                has provided Us with personal data, please contact{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                , and We will delete it promptly.
              </p>
            </div>
          </section>
        </li>
        {/* 12 */}
        <li>
          <section>
            <h2>Links to Other Websites</h2>
            <div>
              <p>
                The Service may contain links to third-party websites and
                resources. This Policy does not apply to them. We do not control
                and are not responsible for their content or data practices, and
                We encourage you to review the privacy policy of any site you
                visit from Ours.
              </p>
            </div>
          </section>
        </li>
        {/* 13 */}
        <li>
          <section>
            <h2>Changes to This Policy</h2>
            <div>
              <p>
                We may update this Policy to reflect changes to the Service, our
                providers, or applicable law. We always publish the current
                version on this page, with the date it was last updated.
              </p>
              <p>
                Where a change is significant, for example, a new purpose of
                processing, a new category of recipient, or a change to the
                legal basis on which We rely, We will bring it to your attention
                by a prominent notice on the Website or, where We hold your
                email address and the change affects you, by email, before the
                change takes effect. This Policy is an information notice rather
                than an agreement, so no acceptance is required from you. Where
                a change concerns processing based on your consent, We will ask
                for fresh consent; you are free to withhold it, and withholding
                it does not affect the lawfulness of anything done before.
              </p>
              <p>
                Previous versions of this Policy are available on request from{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                .
              </p>
            </div>
          </section>
        </li>
        {/* 14 */}
        <li>
          <section>
            <h2>Contact Us</h2>
            <div>
              <p>
                If you have any question, concern, or request relating to this
                Policy or to Our processing of personal data, please contact Us:
              </p>
              <dl>
                <div>
                  <dt>LaSoft | </dt>
                  <dd>
                    <Link to="/">laestimator.ai</Link>
                  </dd>
                </div>
                <div>
                  <dt>Controller: </dt>
                  <dd>LaEurope Sp. z o.o., trading as Lasoft</dd>
                </div>
                <div>
                  <dt>Registered office: </dt>
                  <dd>ul. Piotrkowska 148/150, 90-063 Łódź, Poland</dd>
                </div>
                <div>
                  <dt>NIP: </dt>
                  <dd>8971848582 | REGON: 368844046</dd>
                </div>
                <div>
                  <dt>Email: </dt>
                  <dd>
                    <a
                      href="mailto:info@lasoft.org"
                      content="info@lasoft.org"
                      rel="nofollow"
                    >
                      info@lasoft.org
                    </a>
                  </dd>
                </div>
                <div>
                  <dt>Phone (US): </dt>
                  <dd>+1 206 681 1521</dd>
                </div>
                <div>
                  <dt>Phone (Poland): </dt>
                  <dd>+48 422 202 701</dd>
                </div>
                <div>
                  <dt>Phone (Ukraine): </dt>
                  <dd>+38 091 481 07 01</dd>
                </div>
              </dl>
              <p>© 2026 LaSoft. All rights reserved. | laestimator.ai</p>
            </div>
          </section>
        </li>
      </ul>
    </div>
  </main>
);

export default PrivacyPolicy;
